<script setup lang="ts">
import NavbarMenuButtonTheme from '@/components/navbar/NavbarMenuButtonTheme.vue'
import NavbarBase from '@/components/navbar/NavbarBase.vue'
import NavbarMenuButtonSidebar from '@/components/navbar/NavbarMenuButtonSidebar.vue'
import InputSearchNavbar from '@/components/input/InputSearchNavbar.vue'
</script>

<template>
  <navbar-base class="-ml-4">
    <div class="flex gap-2">
      <navbar-menu-button-sidebar class="self-center"></navbar-menu-button-sidebar>
      <input-search-navbar class="self-center font-bold"></input-search-navbar>
    </div>
    <navbar-menu-button-theme></navbar-menu-button-theme>
  </navbar-base>
</template>

<style scoped></style>
